import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import dayjs, { Dayjs } from "dayjs";
import { DatePicker } from "antd";
export default function LocalDatePicker({ value = null, onChange = undefined, allowClear = true, format = "DD/MM/YYYY", placeholder = "Date" }) {
    function emitOnChange(dayjs) {
        if (dayjs && onChange) {
            onChange(dayjs.format("YYYY-MM-DD"));
        }
        else if (onChange) {
            onChange(null);
        }
    }
    return (_jsx(DatePicker, { value: value ? dayjs(value) : null, onChange: emitOnChange, showTime: false, allowClear: allowClear, format: format, placeholder: placeholder }));
}
